import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useOrgConfig } from '../../../../hooks/useOrgConfig';
import * as actions from '../../Dashbord/_redux/dashboard/Actions';
import { CheckCircle, AlertTriangle, Loader } from 'lucide-react';

export function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate       = useNavigate();
  const dispatch       = useDispatch();
  const { org }        = useOrgConfig();

  const [status,  setStatus]  = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const code  = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      setMessage('Authorization was denied or cancelled. Please try again.');
      return;
    }

    if (!code) {
      setStatus('error');
      setMessage('No authorization code received. Please try again.');
      return;
    }

    // Wait for org to load before making the API call
    if (!org?.organization_id) return;

    async function handleCallback() {
      try {
        await dispatch(actions.addData('oauth_callback', {
          code,
          state,
          organization_id: org.organization_id,
          redirect_uri: `${window.location.origin}/integrations/oauth/callback`,
        }));
        const [provider] = (state || '').split(':');
        setStatus('success');
        setTimeout(() => navigate(
          `/integrations?provider=${encodeURIComponent(provider || '')}&connected=true`,
          { replace: true }
        ), 1500);
      } catch (err) {
        setStatus('error');
        setMessage(err?.response?.data?.message || 'OAuth flow failed. Please try again.');
      }
    }

    handleCallback();
  }, [org?.organization_id]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        {status === 'loading' && (
          <>
            <Loader size={36} style={{ opacity: 0.3, marginBottom: 14, animation: 'int-spin 1s linear infinite' }} />
            <p style={{ fontSize: 14, color: '#64748B', margin: 0 }}>Completing integration setup…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={44} color="#16a34a" style={{ marginBottom: 14 }} />
            <p style={{ fontSize: 15, fontWeight: 700, color: '#16a34a', margin: '0 0 6px' }}>Connected!</p>
            <p style={{ fontSize: 13, color: '#64748B', margin: 0 }}>Redirecting to integrations…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <AlertTriangle size={44} color="#DC2626" style={{ marginBottom: 14 }} />
            <p style={{ fontSize: 15, fontWeight: 700, color: '#DC2626', margin: '0 0 6px' }}>Connection failed</p>
            <p style={{ fontSize: 13, color: '#64748B', margin: '0 0 20px' }}>{message}</p>
            <button
              onClick={() => navigate('/integrations', { replace: true })}
              style={{
                padding: '10px 24px', background: '#5341C4', color: '#fff',
                border: 'none', borderRadius: 8, cursor: 'pointer',
                fontSize: 13, fontWeight: 600,
              }}
            >
              Back to Integrations
            </button>
          </>
        )}
      </div>
    </div>
  );
}
